import React from "react";
import { KgTableIcon } from "../../atoms/KgTableIcon";
import { KgInspectorNavLinkButton } from "../../atoms/KgInspectorNavLinkButton";
import { KgInspectorDataGrid } from "../KgInspectorDataGrid";
import {
  CountBadge,
  EmptyHint,
  IconSlot,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "./KgInspectorTablesTab.styles";
import type { KgInspectorTablesTabProps } from "./KgInspectorTablesTab.types";

export const KgInspectorTablesTab: React.FC<KgInspectorTablesTabProps> = ({
  tables,
  emptyHint = "No tables linked to this data source yet.",
}) => (
    <TabRoot>
      <SectionHeader>
        <IconSlot>
          <KgTableIcon />
        </IconSlot>
        <SectionTitle>Tables</SectionTitle>
        {tables.length > 0 && <CountBadge>{tables.length}</CountBadge>}
      </SectionHeader>

      {tables.length === 0 ? (
        <EmptyHint>{emptyHint}</EmptyHint>
      ) : (
        <KgInspectorDataGrid
          rows={tables}
          rowKey={(row) => row.canvasNodeId ?? row.label}
          columns={[
            {
              key: "name",
              header: "NAME",
              width: "half",
              render: (row) => <KgInspectorNavLinkButton link={row} />,
            },
            {
              key: "primaryKey",
              header: "PRIMARY KEY",
              width: "half",
              render: (row) => row.primaryKey,
            },
          ]}
        />
      )}
    </TabRoot>
);

export default KgInspectorTablesTab;
